import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';


@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent implements OnInit {

  constructor(
    private _router: Router,
    private dialog: MatDialog,
    private _apicall: ApiCallService,
    private _snackBar: SnackbarCollection) { }

  ngOnInit(): void {
    this.getLedgerAndTopicList();
  }

  buttonType = 'create';

  navigateToCreateWalletConfig() {
    this._router.navigate(["/app/wallet/create-wallet-config"]);
  }


  ledgerList = [];
  topicList = [];
  isDataLoading = false;
  getLedgerAndTopicList() {
    this.isDataLoading = true;
    this._apicall.getLedgerAndTopicList().subscribe(
      response => {
        this.isDataLoading = false;
        this.topicList = response["body"].topicList ?? [];
        this.ledgerList = response["body"].ledgerList ?? [];
        if(this.ledgerList.length > 0 || this.topicList.length > 0) {
          this.buttonType = 'edit';
        } else {
          this.buttonType = 'create';
        }
      },
      error => {
        this.isDataLoading = false;
        this._snackBar.openSnackBar("Failed to fetch badges", 2000);
      }
    );
  }

}
